import { MediaType, RightRequestMQLStatus } from '@adalong/schemas';
import type { MediaView } from 'common';

export const hasAgreedCdnVideo = (
  status: RightRequestMQLStatus | undefined,
  videoUrl: string | undefined,
): boolean => status === RightRequestMQLStatus.Agreed && Boolean(videoUrl?.trim());

export const canLoadSubtitleTracks = (
  currentMediaId: string | undefined,
  media: Pick<MediaView, '_id' | 'type' | 'rightsRequestStatus' | 'cdn_video'> | undefined,
  audioFiltersEnabled: boolean | undefined,
): boolean => Boolean(
  audioFiltersEnabled === true
  && currentMediaId
  && media?._id === currentMediaId
  && media.type === MediaType.Video
  && hasAgreedCdnVideo(media.rightsRequestStatus, media.cdn_video),
);
